import { useMatches } from "react-router";
import type { RouteLoader } from "~/lib/types";

export const useRouteData = () => {
  const rootData = useMatches().find((match) => match.id !== "root");
  const routeData = (rootData?.data as RouteLoader<any> | null)?.data?.routeData;
  return routeData;
};
